import dayjs, { Dayjs } from "dayjs";

export const toDateTimeString = (isoString?: string | number | Date | Dayjs | null) => {
    return isoString ? dayjs(isoString).format("YYYY-MM-DDTHH:mm") : isoString;
};

export const toIsoDate = (dateString?: string | number | Date | Dayjs | null) => {
    return  dateString ? new Date(dateString.toString()).toISOString() : dateString;
};